import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "flex items-center justify-between gap-3" };
const _hoisted_2 = { class: "flex flex-col gap-px min-w-0" };
const _hoisted_3 = ["href", "aria-label"];
const _hoisted_4 = { class: "flex items-center gap-2 shrink-0" };
import { computed } from "vue";
import { Badge, PhoneDisplay, formatPhoneForDisplay } from "@eudonet/opal";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganisationChannelRow',
    props: {
        type: {},
        value: {},
        isPrimary: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const isPhone = computed(() => props.type === "phone");
        /** mailto: target for the email branch — PhoneDisplay builds its own tel: href. */
        const contactHref = computed(() => `mailto:${props.value}`);
        /**
         * The phone branch interpolates the FORMATTED value so the announced name matches the visible
         * text (WCAG 2.5.3) — PhoneDisplay renders the number grouped, not raw.
         */
        const actionLabel = computed(() => isPhone.value
            ? t("organisation.detail.communication.callAriaLabel", { value: formatPhoneForDisplay(props.value) })
            : t("organisation.detail.communication.sendEmailAriaLabel", { value: props.value }));
        const primaryLabel = computed(() => isPhone.value
            ? t("organisation.detail.communication.phonePrimary")
            : t("organisation.detail.communication.emailPrimary"));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (isPhone.value)
                        ? (_openBlock(), _createBlock(_unref(PhoneDisplay), {
                            key: 0,
                            value: __props.value,
                            "aria-label": actionLabel.value,
                            class: "text-sm font-medium text-(--text-text-link) truncate no-underline hover:no-underline cursor-pointer rounded-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--colors-border-accent)"
                        }, null, 8 /* PROPS */, ["value", "aria-label"]))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: contactHref.value,
                            "aria-label": actionLabel.value,
                            class: "text-sm font-medium text-(--text-text-link) truncate no-underline hover:no-underline cursor-pointer rounded-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--colors-border-accent)"
                        }, _toDisplayString(__props.value), 9 /* TEXT, PROPS */, _hoisted_3))
                ]),
                _createElementVNode("div", _hoisted_4, [
                    (__props.isPrimary)
                        ? (_openBlock(), _createBlock(_unref(Badge), {
                            key: 0,
                            theme: "yellow",
                            size: "sm",
                            label: primaryLabel.value,
                            "show-left-icon": false,
                            "show-close-icon": false
                        }, null, 8 /* PROPS */, ["label"]))
                        : _createCommentVNode("v-if", true),
                    _renderSlot(_ctx.$slots, "actions")
                ])
            ]));
        };
    }
});
